export const isJsxColumn = (column) => column.renderType === 'jsx';
export const formatJsxCell = (row, column) => {
    const value = row[column.key];
    if (typeof value !== 'object' || !('displayContent' in value)) {
        throw new Error('Cells of type JSX should be objects of type: { displayContent: JSX.Element | JSX.Element[]; sortContent: string}');
    }
    return value.displayContent;
};
export function generateRowKey(row, columns) {
    if (row.reactKey || row.title)
        return `row-${row.reactKey || row.title}`;
    const columnKeys = columns.map((column) => column.key);
    const rowKey = columnKeys
        .map((columnKey) => {
        const column = columns.find((searchColumn) => searchColumn.key === columnKey);
        if (isJsxColumn(column)) {
            if (typeof row[columnKey] !== 'object' ||
                !('sortContent' in row[columnKey])) {
                throw new Error('Cells of type JSX should be objects of type: { displayContent: JSX.Element | JSX.Element[]; sortContent: string}');
            }
            else {
                return row[columnKey].sortContent;
            }
        }
        return row[columnKey];
    })
        .join('-');
    const otherRowKey = Object.keys(row)
        .filter((property) => typeof row[property] === 'object' &&
        row[property] !== null &&
        'key' in row[property])
        .join('-');
    return `row-${rowKey}-${otherRowKey}`;
}
export function formatCell(row, column) {
    if (isJsxColumn(column)) {
        return formatJsxCell(row, column);
    }
    const value = row[column.key];
    switch (column.dataType) {
        case 'percent': {
            return `${value.replace('.', ',')} %`;
        }
        default:
            return value;
    }
}
export function sortRows(rows, sortColumn, sortDirection, sortType) {
    rows.forEach((row) => {
        if ('subRows' in row) {
            sortRows(row.subRows, sortColumn, sortDirection, sortType);
            sortLevel(row.subRows, sortColumn, sortDirection, sortType);
        }
    });
    sortLevel(rows, sortColumn, sortDirection, sortType);
    return rows;
}
export function sortLevel(rows, sortColumn, sortDirection, sortType) {
    switch (sortType) {
        case 'number':
            rows.sort((a, b) => {
                const aValue = isJsxColumn(sortColumn)
                    ? a[sortColumn.key].sortContent
                    : a[sortColumn.key];
                const bValue = isJsxColumn(sortColumn)
                    ? b[sortColumn.key].sortContent
                    : b[sortColumn.key];
                return parseInt(aValue, 10) - parseInt(bValue, 10);
            });
            break;
        default:
            rows.sort((a, b) => {
                const aValue = isJsxColumn(sortColumn)
                    ? a[sortColumn.key].sortContent
                    : a[sortColumn.key];
                const bValue = isJsxColumn(sortColumn)
                    ? b[sortColumn.key].sortContent
                    : b[sortColumn.key];
                return aValue.toLowerCase().localeCompare(bValue);
            });
    }
    if (sortDirection === 'desc')
        rows.reverse();
}
export const getSortTypeForColumn = (columnKey, columns) => {
    const foundColumn = columns.find((column) => column.key === columnKey);
    return foundColumn ? foundColumn.dataType : undefined;
};
